export default __webpack_public_path__ + "static/media/S22SolutionsChallengeAsset2.0b5c0eb6.png";